<template>
    <section class="WhyChoose">
      <h2 class="WhyChoose__title" :class="isPhone ? 'merriweather-reg-18' : 'merriweather-reg-32'">Pourquoi choisir Hortense&nbsp;?</h2>
  
      <div class="WhyChoose__grid">
        <article class="WC__card">
          <div class="WC__media">
            <img :src="imgBed" alt="Lieux soigneusement sélectionnés" loading="lazy" />
          </div>
          <h3 class="WC__k raleway-semi-p15">LIEUX SOIGNEUSEMENT SÉLECTIONNÉS</h3>
          <p class="WC__v raleway-reg-p15">Élégance, confort et capacité à inspirer</p>
        </article>
  
        <article class="WC__card">
          <div class="WC__media">
            <img :src="imgSpa" alt="Accompagnement sur-mesure" loading="lazy" />
          </div>
          <h3 class="WC__k raleway-semi-p15">ACCOMPAGNEMENT SUR-MESURE</h3>
          <p class="WC__v raleway-reg-p15">Programme personnalisé, activités thématiques &amp; restauration locale raffinée</p>
        </article>
  
        <article class="WC__card">
          <div class="WC__media">
            <img :src="imgFood" alt="Démarche éco-responsable" loading="lazy" />
          </div>
          <h3 class="WC__k raleway-semi-p15">DÉMARCHE ÉCO-RESPONSABLE</h3>
          <p class="WC__v raleway-reg-p15">Respect des ressources, hébergements engagés, circuits courts &amp; approche zéro déchet, activités éco-friendly</p>
        </article>
  
        <article class="WC__card">
          <div class="WC__media">
            <img :src="imgMassage" alt="Récompense unique" loading="lazy" />
          </div>
          <h3 class="WC__k raleway-semi-p15">RÉCOMPENSE UNIQUE</h3>
          <p class="WC__v raleway-reg-p15">Hortense offre à vos collaborateurs des attentions uniques et mémorables</p>
        </article>
      </div>
    </section>
  </template>
  
  <script>
  export default {
    name: 'WhyChooseHortense',
    data () {
      return {
        imgBed:     require('../../images/helloworld.webp'),
        imgSpa:     require('../../images/accompagnement-sur-mesure-hortense.webp'),
        imgFood:    require('../../images/hejkdwcj.webp'),
        imgMassage: require('../../images/dqdqwdwq.webp'),
        isPhone: window.innerWidth < 768
      }
    }
  }
  </script>
  
  <style scoped>
  .WhyChoose{
    max-width: 1200px;
    margin: 0 auto;
    padding: clamp(24px, 6vw, 56px) clamp(12px, 4vw, 24px);
  }
  .WhyChoose__title{
    margin: 0 0 clamp(10px, 1.8vw, 14px);
    text-align: center;
    margin: 0 0 clamp(18px, 3vw, 28px);
  }
  .WhyChoose__grid{
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: clamp(14px, 2.2vw, 24px);
  }
  .WC__card{ display:flex; flex-direction:column; }
  .WC__media{
    overflow: hidden;
    background:#f2f2f2;
    margin-bottom: 12px;
  }
  .WC__media img{ width:100%; height:100%; object-fit:cover; display:block; }
  .WC__k{
    letter-spacing: .3px;
    margin: 2px 0 6px;
  }
  .WC__v{
    color:#333;
    line-height: 1.55;
    margin: 0;
  }
  
  @media (max-width: 1024px){
    .WhyChoose__grid{ grid-template-columns: repeat(2, 1fr); }
  }
  @media (max-width: 600px){
    .WhyChoose__grid{ grid-template-columns: 1fr; }
    .WC__media{ aspect-ratio: 16 / 10; }
  }
  </style>
  